export var BusinessType;
(function (BusinessType) {
    BusinessType["Private"] = "PRIVATE";
    BusinessType["Public"] = "PUBLIC";
})(BusinessType || (BusinessType = {}));
//# sourceMappingURL=BusinessType.js.map